import type { EStorageType } from 'reactApp/modules/storage/storage.types';

type ProcessingState = 'processing' | 'error' | 'success' | 'compare';

export type ProcessingType = 'improve' | 'removeBackground';
export type NewBackgroundType = 'transparent' | 'color' | 'mail' | 'cloud';

export interface IAiToolsState {
    processors: Record<
        string,
        {
            state?: ProcessingState;
            imageResult?: string;
            type?: ProcessingType;
            isNewbackground?: boolean;
        }
    >;
    startTime: number;
    startTimeRmvBgrnd: number;
    attemptsAvailable: number;
    attemptsRmvBgrndAvailable: number;
}

export interface AiImageImproveData {
    startTime?: number;
    attemptsAvailable?: number;
    maxAttempts?: number;
}

export const aiImageImproveLocalStorageKey = 'ai-improve-data';
export const aiRmvBgrndLocalStorageKey = 'ai-rmv-backgrnd-data';

export interface AiToolsFeatures {
    improve?: boolean;
    removeBackground?: boolean;
}

export interface ImageProcessRequestData {
    id: string;
    ext: string;
    storage?: EStorageType | null;
    type?: ProcessingType;
}

export interface NewBackground {
    id: string;
    type: NewBackgroundType;
}

export interface IImageProcessor {
    init(): Promise<boolean>;

    removeBackground(
        { ext, url, directUrl }: { ext: string; url?: string; directUrl?: boolean },
        model: string,
        dftype?: string
    ): Promise<
        | undefined
        | { error: string }
        | {
              buffer: ArrayBuffer;
              imageDataUrl: string;
          }
    >;
}
